import './cadastro.css';
import CadastroForm from "./CadastroForm.js";

function Cadastro() {
  return (
    <div className='telaCadastro'>
     <CadastroForm/>
    </div>
  );
}
export default Cadastro;
